import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactV2Component } from './contact-v2.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { PipeModule } from 'src/app/shared/pipe.module';
import { DropdownModule } from 'primeng/dropdown';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { InputSwitchModule } from 'primeng/inputswitch';

@NgModule({
  declarations: [ContactV2Component],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    SplitButtonModule,
    RippleModule,
    PipeModule,
    DropdownModule,
    CardModule,
    DividerModule,
    AvatarModule,
    BadgeModule,
    InputSwitchModule,
  ],
  exports: [ContactV2Component],
})
export class ContactV2Module {}
